module.exports = __webpack_public_path__ + "img/apple.9357892a.png";